import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { getTncDetail, updateTnC } from '../../redux/actions/tnc';
import TncUpdate from './TncUpdate.page';

const mapStateToProps = state => ({
  defaultData: state.allbiller.tncDetail,
  loading: state.allbiller.loading,
});

const mapDispatchToProps = { getTncDetail, updateTnC };

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(TncUpdate));
